/**
 * Hàm hỗ trợ gộp một mảng các nến thành 1 cây nến tổng duy nhất
 */
const aggregateCandleBlock = (candles) => {
  if (!candles || candles.length === 0) return null;
  const firstCandle = candles[0];
  const lastCandle = candles[candles.length - 1];

  let highestPrice = parseFloat(firstCandle[2]);
  let lowestPrice = parseFloat(firstCandle[3]);
  let totalBaseVolume = 0;
  let totalQuoteVolume = 0;
  let totalTrades = 0;
  let totalTakerBuyBaseVolume = 0;
  let totalTakerBuyQuoteVolume = 0;

  for (let i = 0; i < candles.length; i++) {
    const c = candles[i];
    const high = parseFloat(c[2]);
    const low = parseFloat(c[3]);

    if (high > highestPrice) highestPrice = high;
    if (low < lowestPrice) lowestPrice = low;

    totalBaseVolume += parseFloat(c[5]);
    totalQuoteVolume += parseFloat(c[7]);
    totalTrades += parseInt(c[8]);
    totalTakerBuyBaseVolume += parseFloat(c[9]);
    totalTakerBuyQuoteVolume += parseFloat(c[10]);
  }

  return [
    firstCandle[0],                         // [0] Open time
    firstCandle[1],                         // [1] Open price
    highestPrice.toFixed(8),                // [2] High price
    lowestPrice.toFixed(8),                 // [3] Low price
    lastCandle[4],                          // [4] Close price
    totalBaseVolume.toFixed(8),             // [5] Base asset volume
    lastCandle[6],                          // [6] Close time
    totalQuoteVolume.toFixed(8),            // [7] Quote asset volume
    totalTrades,                            // [8] Number of trades
    totalTakerBuyBaseVolume.toFixed(8),     // [9] Taker buy base asset volume
    totalTakerBuyQuoteVolume.toFixed(8),    // [10] Taker buy quote asset volume
    "0"                                     // [11] Ignore
  ];
};

const getBaseMinutes = (interval) => {
  if (interval.endsWith('m')) return parseInt(interval.replace('m', ''));
  if (interval.endsWith('h')) return parseInt(interval.replace('h', '')) * 60;
  return 5; 
};

export const multiTimeframeAggregator = (allCandles, baseInterval = '5m') => {
  if (!allCandles || allCandles.length === 0) return {};
  
  const targetIntervals = [1, 2, 4, 6, 8, 12];
  const finalMatrix = {};
  const baseMinutes = getBaseMinutes(baseInterval);

  targetIntervals.forEach((hours) => {
    const intervalKey = `${hours}H`;
    const numCandlesNeeded = (hours * 60) / baseMinutes;

    const targetCandles = allCandles.slice(-numCandlesNeeded);
    const singleAggregatedCandle = aggregateCandleBlock(targetCandles);
    
    finalMatrix[intervalKey] = singleAggregatedCandle ? [singleAggregatedCandle] : [];
  });

  return finalMatrix;
};

export const fetchAndAggregateData = async (symbol = 'BTCUSDT', interval = '5m', limit = 500) => {
  try {
    const endpoint = `https://fapi.binance.com/fapi/v1/klines?symbol=${symbol.toUpperCase()}&interval=${interval}&limit=${limit}`;
    const response = await fetch(endpoint);
    if (!response.ok) throw new Error(`API lỗi: ${response.status}`);
    const candles = await response.json();
    if (!Array.isArray(candles) || candles.length === 0) throw new Error("Dữ liệu nến rỗng.");

    const aggregatedMatrix = multiTimeframeAggregator(candles, interval);
    return { success: true, symbol: symbol.toUpperCase(), data: aggregatedMatrix };
  } catch (error) {
    return { success: false, error: error.message };
  }
};

// MỚI: Lấy mảng Lịch sử OI chi tiết để match đúng Timestamp
export const fetchOpenInterestHistory = async (symbol = 'BTCUSDT', period = '5m', limit = 500) => {
  try {
    const endpoint = `https://fapi.binance.com/futures/data/openInterestHist?symbol=${symbol.toUpperCase()}&period=${period}&limit=${limit}`;
    const response = await fetch(endpoint);
    if (!response.ok) throw new Error(`API lỗi OI Hist: ${response.status}`);
    const data = await response.json();
    return { success: true, data };
  } catch (error) {
    return { success: false, error: error.message };
  }
};

// MỚI: Lấy mảng Lịch sử Funding Rate
// Cập nhật: Thêm startTime và endTime vào tham số
export const fetchFundingRateHistory = async (symbol = 'BTCUSDT', startTime = null, endTime = null, limit = 500) => {
  try {
    let endpoint = `https://fapi.binance.com/fapi/v1/fundingRate?symbol=${symbol.toUpperCase()}&limit=${limit}`;
    
    // Nếu có truyền thời gian thì nối thêm vào URL API
    if (startTime) endpoint += `&startTime=${startTime}`;
    if (endTime) endpoint += `&endTime=${endTime}`;

    const response = await fetch(endpoint);
    if (!response.ok) throw new Error(`API lỗi Funding: ${response.status}`);
    const data = await response.json();
    return { success: true, data };
  } catch (error) {
    return { success: false, error: error.message };
  }
};

// MỚI: Lấy OI hiện tại
export const fetchCurrentOI = async (symbol = 'BTCUSDT') => {
  try {
    const endpoint = `https://fapi.binance.com/fapi/v1/openInterest?symbol=${symbol.toUpperCase()}`;
    const response = await fetch(endpoint);
    if (!response.ok) throw new Error(`API lỗi Current OI: ${response.status}`);
    const data = await response.json();
    return { success: true, data };
  } catch (error) {
    return { success: false, error: error.message };
  }
};
